
import React, { useState, useEffect } from 'react';
import vidarbhaimg from './images/vidarbha.png';
// Import your slideshow images - replace these with your actual image paths
import slide1 from '../Images/residential1.jpg'; // Add your image path
import slide2 from '../Images/residential2.jpg'; // Add your image path
import slide3 from '../Images/residential3.jpg'; // Add your image path
import slide4 from '../Images/residential4.jpg'; // Add your image path

const testimonials = [
  {
    name: "Anupama Sinha",
    location: "Nagpur, Maharashtra",
    review: "Being an engineer myself, I am extremely satisfied with the team of Blue Sky Energy. They have done an amazing job...",
    rating: 5
  },
  {
    name: "Pradeep Mukharjee",
    location: "Chandrapur, Maharashtra",
    review: "I was looking for a solution for my high electricity bills and Blue Sky Energy provided us with the best one...",
    rating: 5
  }
];

const Commercial = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [stepHoverStates, setStepHoverStates] = useState(Array(7).fill(false));
  const [hoverStates, setHoverStates] = useState({
    ctaButton: false,
    downloadButton: false,
    finalCTA: false
  });
  const [testimonialHoverStates, setTestimonialHoverStates] = useState(
    Array(testimonials.length).fill(false)
  );
  
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [leadCaptured, setLeadCaptured] = useState(false);
  const [awaitingLeadInfo, setAwaitingLeadInfo] = useState(false);
  const [leadStep, setLeadStep] = useState(0);
  const [userData, setUserData] = useState({ name: '', phone: '', city: '' });
  const [messageCount, setMessageCount] = useState(0);
  const [quickReplies, setQuickReplies] = useState([]);

  useEffect(() => {
    if (isChatOpen && chatMessages.length === 0) {
      initChat();
    }
  }, [isChatOpen]);

  const slides = [
    { id: 1, alt: "Solar Installation 1", src: slide1 },
    { id: 2, alt: "Solar Installation 2", src: slide2 },
    { id: 3, alt: "Solar Panel Closeup", src: slide3 },
    { id: 4, alt: "Green Energy Home", src: slide4 }
  ];

  const installationSteps = [
    {
      title: "Free in-home consultation",
      description: "A Blue Sky Energy consultant will survey your home, answer your questions and generate a custom digital design.",
      cta: "Schedule a free consultation"
    },
    {
      title: "Personalised solar proposal & dedicated manager",
      description: "Based on your requirements, our team will create a custom proposal for you."
    },
    {
      title: "Paperwork and subsidy assistance",
      description: "End-to-end paperwork management by us for hassle-free coordination."
    },
    {
      title: "Step-by-step professional & safe installation",
      description: "Your rooftop system will be installed in a timely, clean and professional manner."
    },
    {
      title: "Connection to the grid",
      description: "We coordinate with the discom to connect your system to the power grid."
    },
    {
      title: "Power on your new system",
      description: "Switch on your system to enjoy reduced electricity bills!"
    },
    {
      title: "Deep cleaning and maintenance",
      description: "Quarterly deep cleaning and preventive health checks for 5 years."
    }
  ];

  const stats = [
    { value: "4500+", label: "homes solarised" },
    { value: "4.8", label: "rating on Google" },
    { value: "6000+", label: "reviews" },
    { value: "10+", label: "years of experience" },
    { value: "100+ Cr", label: "saved annually" }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const initChat = () => {
    addChatMessage("Hi 👋 Welcome to Blue Sky Energy! How can we help you with commercial solar today?", 'bot');
    setTimeout(() => {
      addChatMessage("Choose an option to get started:", 'bot');
      setQuickReplies([
        "🏢 Commercial Solar Quote", 
        "💰 ROI Calculation", 
        "📋 Installation Process",
        "📍 Our Service Areas"
      ]);
    }, 800);
  };

  const addChatMessage = (text, sender) => {
    const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const newMessage = {
      text,
      sender,
      time,
      id: Date.now()
    };
    setChatMessages(prev => [...prev, newMessage]);
    if (sender === 'user') {
      setMessageCount(prev => prev + 1);
    }
  };

  const matchKeywords = (input) => {
    const text = input.toLowerCase();
    if (text.includes('human') || text.includes('call') || text.includes('talk')) {
      return "I'd be happy to connect you with our commercial team! 📞\n\nCall us directly: (+91) 80879 32436";
    }
    if (text.includes('commercial') || text.includes('business') || text.includes('industrial')) {
      return "🏢 Commercial Solar Solutions\n\n• ROI typically within 3-5 years\n• Customized solutions for businesses\n• We've installed 25,000+ systems\n\nWould you like a commercial quote?";
    }
    if (text.includes('roi') || text.includes('return') || text.includes('investment')) {
      return "💰 Commercial Solar ROI\n\n• Average ROI: 25-35% annually\n• Payback period: 3-5 years\n• 25+ years system lifespan\n\nShall I connect you with our commercial team?";
    }
    return "I understand you're interested in commercial solar! I can help with ROI calculations, pricing, installation process, or connecting you with our commercial team.";
  };

  const handleLeadCapture = (input) => {
    if (leadStep === 0) {
      setUserData(prev => ({ ...prev, name: input }));
      setLeadStep(1);
      addChatMessage(`Nice to meet you, ${input}! 😊\n\nCould you please share your phone number?`, 'bot');
    } else if (leadStep === 1) {
      setUserData(prev => ({ ...prev, phone: input }));
      setLeadStep(2);
      addChatMessage("Great! And which city are you from?", 'bot');
    } else if (leadStep === 2) {
      setUserData(prev => ({ ...prev, city: input }));
      setLeadCaptured(true);
      setAwaitingLeadInfo(false);
      const leadId = `lead_${Date.now()}`;
      localStorage.setItem(leadId, JSON.stringify({...userData, city: input, timestamp: new Date()}));
      addChatMessage(`Perfect! Thank you ${userData.name}! ✅\n\nOur commercial team will contact you within 24 hours.`, 'bot');
    }
  };

  const handleChatSend = () => {
    const text = chatInput.trim();
    if (!text) return;

    addChatMessage(text, 'user');
    setChatInput('');
    setQuickReplies([]);

    setTimeout(() => {
      if (awaitingLeadInfo) {
        handleLeadCapture(text);
      } else {
        const response = matchKeywords(text);
        addChatMessage(response, 'bot');

        if (!leadCaptured && messageCount >= 1) {
          setTimeout(() => {
            addChatMessage("I'd love to help you with commercial solar! 📋\n\nCan I get your name to assist you better?", 'bot');
            setAwaitingLeadInfo(true);
          }, 1500);
        }
      }
    }, 600);
  };

  const handleQuickReply = (option) => {
    setChatInput(option);
    setTimeout(() => {
      handleChatSend();
    }, 100);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleChatSend();
    }
  };

  const handleStepHover = (index, isHovering) => {
    setStepHoverStates(prev => {
      const newState = [...prev];
      newState[index] = isHovering;
      return newState;
    });
  };

  const handleMouseEnter = (item) => {
    setHoverStates(prev => ({ ...prev, [item]: true }));
  };

  const handleMouseLeave = (item) => {
    setHoverStates(prev => ({ ...prev, [item]: false }));
  };

  const handleTestimonialCardMouseEnter = (index) => {
    setTestimonialHoverStates(prev => {
      const newState = [...prev];
      newState[index] = true;
      return newState;
    });
  };

  const handleTestimonialCardMouseLeave = (index) => {
    setTestimonialHoverStates(prev => {
      const newState = [...prev];
      newState[index] = false;
      return newState;
    });
  };

  return (
    <>
      <style>
        {`
          /* Color Palette */
          :root {
            --color-deep-teal: #061221;
            --color-dark-navy: #123249;
            --color-midnight: #2D5A74;
            --color-slate: #447793;
            --color-frost: #DDE8ED;
            --color-white: #ffffff;
            --gradient-primary: linear-gradient(135deg, #447793 0%, #2D5A74 100%);
            --gradient-hover: linear-gradient(135deg, #2D5A74 0%, #123249 100%);
            --gradient-light: linear-gradient(135deg, #DDE8ED 0%, #ffffff 100%);
            --shadow-sm: 0 2px 15px rgba(6, 18, 33, 0.08);
            --shadow-md: 0 4px 20px rgba(6, 18, 33, 0.12);
            --shadow-lg: 0 10px 30px rgba(6, 18, 33, 0.15);
          }

          /* Responsive CSS */
          @media (max-width: 1200px) {
            .section {
              padding: 60px 20px !important;
            }
            
            .hero-title {
              font-size: 2.8rem !important;
            }
            
            .hero-subtitle {
              font-size: 1.2rem !important;
            }
          }
          
          @media (max-width: 992px) {
            .hero-title {
              font-size: 2.3rem !important;
            }
            
            .hero-subtitle {
              font-size: 1.1rem !important;
            }
            
            .section-title {
              font-size: 2.2rem !important;
            }
            
            .section-subtitle {
              font-size: 1.1rem !important;
            }
            
            .step-content-left,
            .step-content-right {
              margin: 0 !important;
              width: calc(100% - 80px) !important;
              text-align: left !important;
              border-right: none !important;
              border-left: 5px solid #447793 !important;
            }
            
            .step {
              flex-direction: column !important;
              align-items: flex-start !important;
              margin-bottom: 40px !important;
            }
            
            .step-number-circle {
              position: relative !important;
              left: 0 !important;
              transform: none !important;
              margin-bottom: 20px !important;
              margin-left: 10px !important;
              top: 0 !important;
            }
            
            .step-line {
              left: 35px !important;
              height: 100% !important;
            }
          }
          
          @media (max-width: 768px) {
            .hero-section {
              height: 50vh !important;
            }
            
            .hero-title {
              font-size: 1.8rem !important;
              margin-bottom: 15px !important;
            }
            
            .hero-subtitle {
              font-size: 1rem !important;
              margin-bottom: 30px !important;
            }
            
            .cta-button, .download-button, .step-cta {
              padding: 12px 25px !important;
              font-size: 1rem !important;
            }
            
            .section {
              padding: 40px 15px !important;
            }
            
            .section-title {
              font-size: 1.8rem !important;
              margin-bottom: 15px !important;
            }
            
            .section-subtitle {
              font-size: 1rem !important;
              margin-bottom: 40px !important;
              padding: 0 10px !important;
            }
            
            .stats-grid {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 20px !important;
            }
            
            .stat-value {
              font-size: 2.2rem !important;
            }
            
            .stat-label {
              font-size: 0.9rem !important;
            }
            
            .step-content-left,
            .step-content-right {
              padding: 20px !important;
              width: calc(100% - 60px) !important;
              margin-left: 60px !important;
            }
            
            .step-title {
              font-size: 1.3rem !important;
            }
            
            .step-description {
              font-size: 1rem !important;
            }
            
            .step-number-circle {
              width: 50px !important;
              height: 50px !important;
            }
            
            .step-number {
              font-size: 1.4rem !important;
            }
            
            .testimonial-grid {
              grid-template-columns: 1fr !important;
              gap: 20px !important;
            }
            
            .testimonial-card {
              padding: 20px !important;
            }
            
            .guide-title {
              font-size: 1.8rem !important;
            }
            
            .guide-subtitle {
              font-size: 1rem !important;
            }
            
            .map-placeholder {
              height: 300px !important;
            }
            
            /* Chatbot Mobile */
            .chat-window {
              width: 90vw !important;
              right: 5vw !important;
              left: 5vw !important;
              height: 500px !important;
            }
            
            .chat-message {
              max-width: 85% !important;
              font-size: 13px !important;
              padding: 10px 14px !important;
            }
            
            .reply-btn {
              font-size: 12px !important;
              padding: 6px 12px !important;
            }
            
            .chat-input {
              font-size: 13px !important;
              padding: 10px 14px !important;
            }
            
            .send-btn {
              width: 40px !important;
              height: 40px !important;
              font-size: 14px !important;
            }
            
            .chat-toggle-btn {
              width: 55px !important;
              height: 55px !important;
              font-size: 22px !important;
            }
          }
          
          @media (max-width: 576px) {
            .hero-section {
              height: 45vh !important;
            }
            
            .hero-title {
              font-size: 1.5rem !important;
            }
            
            .hero-subtitle {
              font-size: 0.9rem !important;
            }
            
            .section-title {
              font-size: 1.6rem !important;
            }
            
            .stats-grid {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 15px !important;
            }
            
            .stat-value {
              font-size: 1.8rem !important;
            }
            
            .step-content-left,
            .step-content-right {
              margin-left: 50px !important;
              width: calc(100% - 50px) !important;
              padding: 15px !important;
            }
            
            .step-title {
              font-size: 1.2rem !important;
            }
            
            .step-description {
              font-size: 0.95rem !important;
            }
            
            .download-guide {
              padding: 40px 15px !important;
            }
            
            .guide-title {
              font-size: 1.5rem !important;
            }
            
            .final-cta {
              padding: 15px 40px !important;
              font-size: 1.1rem !important;
            }
            
            .chat-window {
              width: 95vw !important;
              right: 2.5vw !important;
              left: 2.5vw !important;
              height: 450px !important;
            }
          }
          
          @media (max-width: 480px) {
            .hero-section {
              height: 40vh !important;
            }
            
            .hero-title {
              font-size: 1.3rem !important;
            }
            
            .hero-content {
              width: 90% !important;
            }
            
            .section {
              padding: 30px 10px !important;
            }
            
            .stats-grid {
              grid-template-columns: 1fr !important;
              gap: 20px !important;
            }
            
            .step-content-left,
            .step-content-right {
              margin-left: 40px !important;
              width: calc(100% - 40px) !important;
              padding: 12px !important;
            }
            
            .step-number-circle {
              width: 40px !important;
              height: 40px !important;
              margin-left: 0 !important;
            }
            
            .step-number {
              font-size: 1.2rem !important;
            }
            
            .map-placeholder {
              height: 250px !important;
            }
            
            .guide-title {
              font-size: 1.3rem !important;
            }
            
            .chat-window {
              height: 400px !important;
            }
          }
          
          /* Touch-friendly styles */
          @media (hover: none) and (pointer: coarse) {
            .step-content-left:hover,
            .step-content-right:hover,
            .testimonial-card:hover,
            .cta-button:hover,
            .download-button:hover,
            .step-cta:hover {
              transform: none !important;
            }
          }
          
          /* Prevent zoom on mobile input */
          @media (max-width: 768px) {
            input, textarea, select {
              font-size: 16px !important;
            }
          }
          
          /* Smooth transitions */
          .step-content-left,
          .step-content-right,
          .testimonial-card,
          .cta-button,
          .download-button,
          .step-cta {
            transition: all 0.3s ease;
          }
          
          /* Custom animations */
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `}
      </style>

      <div style={{
        fontFamily: "Cambria, serif",
        color: "#123249",
        backgroundColor: "#ffffff",
        position: "relative",
        overflowX: "hidden"
      }}>
        {/* Hero Section - Blue Theme */}
        <section className="hero-section" style={{
          position: "relative",
          height: "60vh",
          overflow: "hidden",
          backgroundColor: "#123249"
        }}>
          <div style={{
            width: "100%",
            height: "100%",
            position: "relative"
          }}>
            {/* Slideshow Images as Background */}
            {slides.map((slide, index) => (
              <div
                key={slide.id}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "120%",
                  height: "200%",
                  marginLeft:'-20px',
                  marginTop:"-100px",
                  opacity: index === currentSlide ? 1 : 0,
                  transition: "opacity 1s ease-in-out",
                  zIndex: 1
                }}
              >
                <div style={{
                  width: "100%",
                  height: "100%",
                  backgroundImage: `url(${slide.src})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  filter: "brightness(0.7)",
                  position: "absolute",
                  top: 0,
                  left: 0
                }} />
                {/* Dark overlay for better text contrast */}
                <div style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(6, 18, 33, 0.4)",
                  zIndex: 1
                }} />
              </div>
            ))}
            
            {/* Slide Indicators */}
            <div style={{
              position: "absolute",
              bottom: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "10px",
              zIndex: 3
            }}>
              {slides.map((_, index) => (
                <div
                  key={index}
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: index === currentSlide ? "#447793" : "rgba(255,255,255,0.5)",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    transform: index === currentSlide ? "scale(1.2)" : "none"
                  }}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
          
          <div className="hero-content" style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
            textAlign: "center",
            color: "white",
            width: "80%"
          }}>
            <h1 className="hero-title" style={{
              fontSize: "3rem",
              fontWeight: "800",
              marginBottom: "1rem",
              textShadow: "2px 2px 4px rgba(6, 18, 33, 0.5)"
            }}>
              ON OUR WAY TO POWER YOUR HOME WITH SOLAR
            </h1>
            <p className="hero-subtitle" style={{
              fontSize: "1.3rem",
              marginBottom: "2rem",
              textShadow: "1px 1px 3px rgba(6, 18, 33, 0.5)"
            }}>
              Your roof, your solar, our responsibility. End to end service.
            </p>
            <button 
              className="cta-button"
              style={{
                backgroundColor: "#447793",
                color: "white",
                padding: "14px 35px",
                fontSize: "1.1rem",
                fontWeight: "bold",
                border: "none",
                borderRadius: "50px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 15px rgba(6, 18, 33, 0.2)"
              }}
              onMouseEnter={() => handleMouseEnter('ctaButton')}
              onMouseLeave={() => handleMouseLeave('ctaButton')}
            >
              Get a quote
            </button>
          </div>
        </section>

        {/* About Us Section - Blue Theme */}
        <section className="section" style={{
          padding: "60px 20px",
          maxWidth: "1400px",
          margin: "0 auto"
        }}>
          <h2 className="section-title" style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            color: "#123249",
            textAlign: "center",
            marginBottom: "20px",
            position: "relative"
          }}>
            Who are we?
            <div style={{
              content: '""',
              position: "absolute",
              bottom: "-10px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "100px",
              height: "4px",
              backgroundColor: "#447793"
            }}></div>
          </h2>
          <p className="section-subtitle" style={{
            fontSize: "1.1rem",
            color: "#2D5A74",
            textAlign: "center",
            marginBottom: "60px",
            maxWidth: "800px",
            margin: "0 auto 60px"
          }}>
            We are a group of 1000+ engineers, MBAs, scientists, creative thinkers driven by the vision 
            of accelerating adoption of solar in homes.
          </p>

          {/* Stats - Blue Theme */}
          <div style={{
            backgroundColor: "#123249",
            padding: "50px 20px",
            margin: "40px 0",
            borderRadius: "15px",
            color: "white",
            position: "relative",
            overflow: "hidden"
          }}>
            {/* Subtle background pattern */}
            <div style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: "radial-gradient(circle at 20% 80%, rgba(68, 119, 147, 0.1) 0%, transparent 20%), radial-gradient(circle at 80% 20%, rgba(68, 119, 147, 0.1) 0%, transparent 20%)",
              zIndex: 0
            }} />
            <div className="stats-grid" style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
              gap: "30px",
              textAlign: "center",
              position: "relative",
              zIndex: 1
            }}>
              {stats.map((stat, index) => (
                <div key={index}>
                  <div className="stat-value" style={{
                    fontSize: "2.5rem",
                    fontWeight: "800",
                    color: "#DDE8ED",
                    marginBottom: "10px"
                  }}>{stat.value}</div>
                  <div className="stat-label" style={{
                    fontSize: "1rem",
                    color: "#DDE8ED"
                  }}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* The Solar Switch Made Simple Section - Blue Theme */}
        <section className="section" style={{
          padding: "60px 20px",
          maxWidth: "1400px",
          margin: "0 auto"
        }}>
          <h2 className="section-title" style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            color: "#123249",
            textAlign: "center",
            marginBottom: "20px",
            position: "relative"
          }}>
            The solar switch made simple
            <div style={{
              content: '""',
              position: "absolute",
              bottom: "-10px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "100px",
              height: "4px",
              backgroundColor: "#447793"
            }}></div>
          </h2>
          <p className="section-subtitle" style={{
            fontSize: "1.1rem",
            color: "#2D5A74",
            textAlign: "center",
            marginBottom: "60px",
            maxWidth: "800px",
            margin: "0 auto 60px"
          }}>
            Switching to solar can seem daunting, but we've got you covered.
          </p>

          {/* Step-by-Step Process */}
          <div style={{
            position: "relative",
            marginBottom: "60px",
            padding: "40px 0"
          }}>
            <div style={{
              position: "absolute",
              left: "50px",
              top: "0",
              bottom: "0",
              width: "2px",
              backgroundColor: "#2D5A74",
              opacity: "0.3",
              zIndex: "1"
            }}></div>
            
            {installationSteps.map((step, index) => (
              <div 
                key={index} 
                className="step"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginBottom: "50px",
                  position: "relative",
                  zIndex: "2",
                  minHeight: "120px"
                }}
              >
                <div className="step-number-circle" style={{
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#447793",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: "0",
                  zIndex: "2",
                  boxShadow: "0 4px 15px rgba(68, 119, 147, 0.2)",
                  position: "relative"
                }}>
                  <div className="step-number" style={{
                    color: "white",
                    fontSize: "1.5rem",
                    fontWeight: "700"
                  }}>
                    {index + 1}
                  </div>
                </div>
                
                <div 
                  className="step-content-right"
                  style={{
                    backgroundColor: "#DDE8ED",
                    padding: "25px 30px",
                    borderRadius: "12px",
                    borderLeft: "5px solid #447793",
                    boxShadow: "0 4px 15px rgba(6, 18, 33, 0.05)",
                    transition: "all 0.3s ease",
                    marginLeft: "40px"
                  }}
                  onMouseEnter={() => handleStepHover(index, true)}
                  onMouseLeave={() => handleStepHover(index, false)}
                >
                  <h3 className="step-title" style={{
                    fontSize: "1.4rem",
                    fontWeight: "600",
                    color: "#123249",
                    marginBottom: "12px"
                  }}>{step.title}</h3>
                  <p className="step-description" style={{
                    fontSize: "1.05rem",
                    color: "#2D5A74",
                    lineHeight: "1.6",
                    marginBottom: "15px"
                  }}>{step.description}</p>
                  
                  {index === 0 && step.cta && (
                    <button 
                      className="step-cta"
                      style={{
                        backgroundColor: "#447793",
                        color: "white",
                        padding: "10px 25px",
                        fontSize: "1rem",
                        fontWeight: "600",
                        textDecoration: "none",
                        borderRadius: "25px",
                        transition: "all 0.3s ease",
                        border: "none",
                        cursor: "pointer",
                        marginTop: "10px"
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#2D5A74";
                        e.target.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#447793";
                        e.target.style.transform = "none";
                      }}
                    >
                      {step.cta}
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Testimonials - Blue Theme */}
        <section className="section" style={{
          backgroundColor: "#DDE8ED",
          padding: "60px 20px",
          position: "relative"
        }}>
          <h2 className="section-title" style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            color: "#123249",
            textAlign: "center",
            marginBottom: "20px",
            position: "relative"
          }}>
            90% of customers recommend us!
            <div style={{
              content: '""',
              position: "absolute",
              bottom: "-10px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "100px",
              height: "4px",
              backgroundColor: "#447793"
            }}></div>
          </h2>
          <p className="section-subtitle" style={{
            fontSize: "1.1rem",
            color: "#2D5A74",
            textAlign: "center",
            marginBottom: "60px",
            maxWidth: "800px",
            margin: "0 auto 60px"
          }}>
            Hear what our satisfied customers have to say
          </p>
          
          <div className="testimonial-grid" style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "30px",
            marginTop: "50px"
          }}>
            {testimonials.map((testimonial, index) => (
              <div 
                key={index} 
                className="testimonial-card"
                style={{
                  backgroundColor: "white",
                  padding: "25px",
                  borderRadius: "15px",
                  boxShadow: "0 5px 15px rgba(6, 18, 33, 0.05)",
                  transition: "all 0.3s ease",
                  position: "relative",
                  overflow: "hidden"
                }}
                onMouseEnter={() => handleTestimonialCardMouseEnter(index)}
                onMouseLeave={() => handleTestimonialCardMouseLeave(index)}
              >
                <div style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "5px",
                  backgroundColor: "#447793"
                }} />
                <p style={{
                  fontStyle: "italic",
                  color: "#2D5A74",
                  lineHeight: "1.7",
                  marginBottom: "20px",
                  fontSize: "1.1rem"
                }}>"{testimonial.review}"</p>
                <div>
                  <div style={{
                    fontWeight: "600",
                    color: "#123249",
                    fontSize: "1.1rem"
                  }}>{testimonial.name}</div>
                  <div style={{
                    color: "#2D5A74",
                    fontSize: "0.9rem",
                    marginTop: "5px"
                  }}>{testimonial.location}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Locations - Blue Theme */}
        <section className="section" style={{
          padding: "60px 20px",
          maxWidth: "1400px",
          margin: "0 auto"
        }}>
          <h2 className="section-title" style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            color: "#123249",
            textAlign: "center",
            marginBottom: "20px",
            position: "relative"
          }}>
            Blue Sky Energy locations
            <div style={{
              content: '""',
              position: "absolute",
              bottom: "-10px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "100px",
              height: "4px",
              backgroundColor: "#447793"
            }}></div>
          </h2>
          <p className="section-subtitle" style={{
            fontSize: "1.1rem",
            color: "#2D5A74",
            textAlign: "center",
            marginBottom: "60px",
            maxWidth: "800px",
            margin: "0 auto 60px"
          }}>
            We offer solar services in 10+ Maharashtra cities, and are expanding every day!
          </p>
          
          <div style={{
            maxWidth: "900px",
            margin: "0 auto",
            backgroundColor: "#DDE8ED",
            padding: "20px",
            borderRadius: "10px",
            position: "relative",
            overflow: "hidden"
          }}>
            <div className="map-placeholder" style={{
              width: "100%",
              height: "400px",
              backgroundColor: "#DDE8ED",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#123249",
              fontSize: "1.1rem",
              borderRadius: "8px",
              fontWeight: "600",
              position: "relative",
              overflow: "hidden"
            }}>
              <img 
                src={vidarbhaimg} 
                alt="Service Locations" 
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'cover',
                  position: 'absolute',
                  top: 0,
                  left: 0
                }}
              />
            </div>
          </div>
        </section>

        {/* Download Guide - Blue Theme */}
        <section className="download-guide" style={{
          backgroundColor: "#123249",
          color: "white",
          padding: "50px 20px",
          borderRadius: "15px",
          textAlign: "center",
          margin: "60px auto",
          maxWidth: "1000px",
          position: "relative",
          overflow: "hidden"
        }}>
          {/* Background pattern */}
          <div style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: "radial-gradient(circle at 30% 70%, rgba(68, 119, 147, 0.1) 0%, transparent 30%), radial-gradient(circle at 70% 30%, rgba(68, 119, 147, 0.1) 0%, transparent 30%)",
            zIndex: 0
          }} />
          <div style={{ position: "relative", zIndex: 1 }}>
            <h2 className="guide-title" style={{
              fontSize: "2.2rem",
              marginBottom: "20px",
              color: "white"
            }}>
              Homeowners Guide To Buying Rooftop Solar
            </h2>
            <p className="guide-subtitle" style={{
              fontSize: "1.1rem",
              opacity: "0.9",
              marginBottom: "30px",
              maxWidth: "700px",
              margin: "0 auto",
              color: "#DDE8ED"
            }}>
              Learn everything you need to know before installing a rooftop solar system.
            </p>
            <button 
              className="download-button"
              style={{
                backgroundColor: "#447793",
                color: "white",
                padding: "14px 45px",
                fontSize: "1.1rem",
                fontWeight: "bold",
                border: "none",
                borderRadius: "50px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 15px rgba(6, 18, 33, 0.2)"
              }}
              onMouseEnter={() => handleMouseEnter('downloadButton')}
              onMouseLeave={() => handleMouseLeave('downloadButton')}
            >
              Download for free
            </button>
          </div>
        </section>

        {/* Final CTA - Blue Theme */}
        <section style={{ 
          padding: "60px 20px", 
          textAlign: "center", 
          maxWidth: "1400px", 
          margin: "0 auto",
          position: "relative"
        }}>
          <h2 style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            color: "#123249",
            marginBottom: "40px",
            position: "relative"
          }}>
            Ready to Start Your Solar Journey?
            <div style={{
              content: '""',
              position: "absolute",
              bottom: "-10px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "100px",
              height: "4px",
              backgroundColor: "#447793"
            }}></div>
          </h2>
          <button 
            className="final-cta"
            style={{
              backgroundColor: "#447793",
              color: "white",
              padding: "16px 50px",
              fontSize: "1.2rem",
              fontWeight: "bold",
              border: "none",
              borderRadius: "50px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 15px rgba(68, 119, 147, 0.3)"
            }}
            onMouseEnter={() => handleMouseEnter('finalCTA')}
            onMouseLeave={() => handleMouseLeave('finalCTA')}
          >
            Call us: +91 80879 32436
          </button>
        </section>

        {/* Chatbot Component - Blue Theme */}
        <div style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: "9999"
        }}>
          {/* Chat Toggle Button */}
          <button 
            className="chat-toggle-btn"
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              width: "55px",
              height: "55px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #447793, #2D5A74)",
              color: "white",
              border: "none",
              fontSize: "22px",
              cursor: "pointer",
              boxShadow: "0 8px 30px rgba(68, 119, 147, 0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: "10000",
              padding: "0",
              transition: "all 0.3s ease"
            }}
            onClick={() => setIsChatOpen(!isChatOpen)}
            onMouseEnter={(e) => {
              e.target.style.background = "linear-gradient(135deg, #2D5A74, #123249)";
              e.target.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "linear-gradient(135deg, #447793, #2D5A74)";
              e.target.style.transform = "none";
            }}
          >
            💬
          </button>

          {/* Chat Window */}
          <div className="chat-window" style={{
            position: "fixed",
            bottom: "85px",
            right: "20px",
            width: "350px",
            height: "500px",
            background: "white",
            borderRadius: "16px",
            boxShadow: "0 10px 40px rgba(6, 18, 33, 0.15)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            zIndex: "9999",
            transition: "all 0.3s ease",
            opacity: isChatOpen ? "1" : "0",
            visibility: isChatOpen ? "visible" : "hidden",
            transform: isChatOpen ? "translateY(0)" : "translateY(20px)",
            border: "1px solid #DDE8ED"
          }}>
            {/* Chat Header */}
            <div style={{
              background: "linear-gradient(135deg, #447793, #2D5A74)",
              color: "white",
              padding: "15px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
            }}>
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}>
                <div style={{
                  background: "rgba(255, 255, 255, 0.2)",
                  padding: "8px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "36px",
                  height: "36px",
                  fontSize: "16px"
                }}>
                  ☀️
                </div>
                <div>
                  <h3 style={{ margin: "0", fontSize: "15px", fontWeight: "600", color: "white" }}>
                    Blue Sky Energy
                  </h3>
                  <p style={{ margin: "0", fontSize: "11px", opacity: "0.9", color: "#DDE8ED" }}>
                    Commercial Solar Experts
                  </p>
                </div>
              </div>
              <button 
                style={{
                  background: "none",
                  border: "none",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "16px",
                  padding: "5px"
                }}
                onClick={() => setIsChatOpen(false)}
              >
                ✕
              </button>
            </div>

            {/* Quick Replies */}
            {quickReplies.length > 0 && (
              <div className="quick-replies" style={{
                padding: "12px",
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                background: "#DDE8ED",
                borderBottom: "1px solid #DDE8ED"
              }}>
                {quickReplies.map((option, index) => (
                  <button
                    key={index}
                    className="reply-btn"
                    style={{
                      background: "white",
                      border: "1px solid #447793",
                      color: "#123249",
                      padding: "8px 16px",
                      borderRadius: "20px",
                      fontSize: "13px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      whiteSpace: "nowrap",
                      fontWeight: "500"
                    }}
                    onClick={() => handleQuickReply(option)}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#447793";
                      e.target.style.color = "white";
                      e.target.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "white";
                      e.target.style.color = "#123249";
                      e.target.style.transform = "none";
                    }}
                  >
                    {option}
                  </button>
                ))}
              </div>
            )}

            {/* Chat Messages */}
            <div className="chat-messages" style={{
              flex: "1",
              padding: "15px",
              background: "#DDE8ED",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "10px"
            }}>
              {chatMessages.map((msg) => (
                <div 
                  key={msg.id} 
                  className="chat-message"
                  style={{
                    maxWidth: "80%",
                    padding: "10px 14px",
                    borderRadius: "18px",
                    fontSize: "14px",
                    lineHeight: "1.5",
                    whiteSpace: "pre-line",
                    wordWrap: "break-word",
                    position: "relative",
                    ...(msg.sender === 'bot' ? {
                      background: "white",
                      alignSelf: "flex-start",
                      borderBottomLeftRadius: "4px",
                      boxShadow: "0 2px 8px rgba(6, 18, 33, 0.08)",
                      color: "#123249",
                      border: "1px solid #DDE8ED"
                    } : {
                      background: "linear-gradient(135deg, #447793, #2D5A74)",
                      color: "white",
                      alignSelf: "flex-end",
                      borderBottomRightRadius: "4px"
                    })
                  }}
                >
                  {msg.text}
                  <span style={{
                    fontSize: "11px",
                    marginTop: "6px",
                    display: "block",
                    opacity: "0.7"
                  }}>
                    {msg.time}
                  </span>
                </div>
              ))}
            </div>

            {/* Chat Input */}
            <div style={{
              padding: "15px",
              borderTop: "1px solid #DDE8ED",
              background: "white"
            }}>
              <div style={{
                display: "flex",
                gap: "10px",
                marginBottom: "8px"
              }}>
                <input
                  type="text"
                  value={chatInput}
                  onChange={(e) => setChatInput(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Type your message..."
                  className="chat-input"
                  style={{
                    flex: "1",
                    padding: "12px 16px",
                    border: "1px solid #DDE8ED",
                    borderRadius: "25px",
                    outline: "none",
                    fontSize: "14px",
                    fontFamily: "Cambria, serif",
                    color: "#123249"
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#447793"}
                  onBlur={(e) => e.target.style.borderColor = "#DDE8ED"}
                />
                <button 
                  className="send-btn"
                  style={{
                    background: "linear-gradient(135deg, #447793, #2D5A74)",
                    color: "white",
                    border: "none",
                    width: "45px",
                    height: "45px",
                    borderRadius: "50%",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                    transition: "all 0.2s ease"
                  }}
                  onClick={handleChatSend}
                  onMouseEnter={(e) => {
                    e.target.style.background = "linear-gradient(135deg, #2D5A74, #123249)";
                    e.target.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "linear-gradient(135deg, #447793, #2D5A74)";
                    e.target.style.transform = "none";
                  }}
                >
                  📤
                </button>
              </div>
              <p className="footer-text" style={{
                textAlign: "center",
                fontSize: "11px",
                color: "#2D5A74",
                margin: "0"
              }}>
                Powered by Blue Sky Energy
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Commercial;